import { render, staticRenderFns } from "./configs-error.vue?vue&type=template&id=3a100e30&scoped=true"
import script from "./configs-error.vue?vue&type=script&lang=js"
export * from "./configs-error.vue?vue&type=script&lang=js"
import style0 from "./configs-error.vue?vue&type=style&index=0&id=3a100e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a100e30",
  null
  
)

export default component.exports